App.OrdersMapOrderController = Em.Controller.extend
  needs: [ 'ordersMap' ]

  env:     Em.inject.service('environment')
  session: Em.inject.service('session')

  orderBinding:    'controllers.ordersMap.selectedOrder'
  couriersBinding: 'controllers.ordersMap.couriers'
